import styles from "./CtaLink.module.css";

const CtaLink = () => {
  return (
    <div className={styles.cta}>
      <a className={styles.ctaLink} href="/">
        Click here to book your slot
      </a>
    </div>
  );
};

export default CtaLink;
